import {query} from "@/graphql/client";
import {gql} from "@urql/vue";
import {EmployeeMonthSummary, EmployeePlannedAbsenceConstraints, MonthKpi} from "@/graphql/generated/graphql";
import {kapitelDateString, kapitelMonthString} from "@/graphql/kapitelTypes";
import {graphql} from "@/graphql/generated";

export const employeePlannedAbsenceConstraints = graphql(`fragment EmployeePlannedAbsenceConstraintsFragment on EmployeePlannedAbsenceConstraints {
    validMonth
    
    aZK
    plannedOrUsedVacation
    remainingUnplannedVacation
}`)


export async function fetchEmployeePlannedAbsenceConstraints(month: kapitelMonthString): Promise<EmployeePlannedAbsenceConstraints> {
    const result = await query(
        graphql(`query getEmployeePlannedAbsenceConstraints($month: KapitelDateImmutable!) {            
            employeePlannedAbsenceConstraints(month: $month) {
                ...EmployeePlannedAbsenceConstraintsFragment
            }
        }`),
        {month}
    )

    return result.data.employeePlannedAbsenceConstraints
}

export async function fetchEmployeePlannedAbsenceConstraintsHistory(begin: kapitelMonthString, until: kapitelMonthString): Promise<EmployeePlannedAbsenceConstraints[]> {
    const result = await query(
        graphql(`query getEmployeePlannedAbsenceConstraintsHistory($begin: KapitelDateImmutable!, $until: KapitelDateImmutable!) {            
            employeePlannedAbsenceConstraintsHistory(begin: $begin, until: $until) {
                ...EmployeePlannedAbsenceConstraintsFragment
            }
        }`),
        {begin, until}
    )

    return result.data.employeePlannedAbsenceConstraintsHistory
}
